// removed by extract-text-webpack-plugin
module.exports = {"nav":"_1HmbcR1ZJ-_wzTLWj0tNgu","nav-prev":"_1kvRWHoI5C_T7aiBpRdwV0","nav-next":"_1fl01RKPRHY_3_Ytfy0lUP","block":"_1wtKvvIpXWbKevVzHu_DRw","slides":"_38c23rz0BiCrWLxpyQqBqT","slides-wrapper":"_1QXjtk01Yk8vWiMBgLGrMk","nav-indicators":"_1S96T2kU27Y6qmBaQ_u3-A","active":"_2jkV5JoNEl_moXP7azOesV","direction-forward":"_38RMc_kvCN2_3nkF6Pc14l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HMSBlock/HMSBlock.module.scss
// module id = 773
// module chunks = 0